import { useSessionStore } from '@/stores/SessionStore.ts';

export default {
  isGuest(to: any, from: any, next: any): void {
    if (useSessionStore().isValid()) {
      // Redirect to a Dashboard if the user isn't a guest
      next({ name: 'Dashboard' });
      return;
    }

    next();
  },
  isAuthenticated(to: any, from: any, next: any): void {
    // Continue current navigation if session not expired,
    // else redirect to the sign in page.
    next(useSessionStore().accessToken !== null ? true : { name: 'SignIn' });
  },
  isFullySignedIn(to: any, from: any, next: any): void {
    if (
      useSessionStore().accessToken === null ||
      useSessionStore().company === null
    ) {
      next({ name: 'SignIn', query: { nextUrl: to.fullPath } });
    } else {
      next();
    }
  },
};
